import { Injectable } from '@angular/core';
import { StoreObject, TypePolicies } from '@apollo/client';

import {
	getSysApiTypePolicies,
	getSysApiTypenameMap,
	mergePolicyNoKey,
	mergePolicyNoKeyKeepTypename,
	mergePolicyUseNewValue
} from '@shure/shared/typescript/data-access/system-api-apollo-cache-config';

import { ApolloTypePolicyProvider } from '../apollo-type-policy.provider';

@Injectable({
	providedIn: 'root'
})
export class SysApiTypePolicyProvider implements ApolloTypePolicyProvider {
	// eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
	typenameMap(): { [__typename: string]: (storeObject: Readonly<StoreObject>) => string } {
		return getSysApiTypenameMap();
	}

	public typePolicies(): TypePolicies {
		return {
			...getSysApiTypePolicies(),

			// Cloud-specific type policies
			AudioChannelSupportedFeatures: mergePolicyNoKey,
			DeviceSupportedFeatures: mergePolicyNoKey,
			DeviceCloudGatewayChange: mergePolicyNoKeyKeepTypename(),
			DeviceExtendedWarrantyChange: mergePolicyNoKeyKeepTypename(),
			DevicePairedDevicesChange: mergePolicyNoKeyKeepTypename(),
			CloudGatewayDiscoveredDevice: mergePolicyUseNewValue,
			CloudGatewayDeviceDiscoveryResult: mergePolicyUseNewValue
		};
	}
}
